import Details from './ProductDetails';
import Added from './Added';

export {
  Added,
  Details,
};
